import React, { useState, useContext, useEffect } from "react";
import styles from "./Firing.module.css";
import { store } from "../../Components/HOC/State";
import UnitListItem from "../MilUnitList/UnitListItem";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faArrowLeft,
  } from "@fortawesome/free-solid-svg-icons";
import { axiosInstance } from "../../Helpers/axiosInstance";
import "react-datepicker/dist/react-datepicker.css";
import baseStyle from "../BaseList/BaseList.module.css";
import FiringParts from "../../Modals/Firing/FiringParts";
import { BACKEND_URL } from "../../Helpers/constants";
import FiringInfo from "./FiringInfo/FiringInfo";
import DatePicker from "react-datepicker";

const Firing = () => {
  const [isBaseListShown, setIsBaseListShown] = useState(false);
  const [selectedName, setSelectedName] = useState("Զորամաս");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentBase, setCurrentBase] = useState();
  const [currentUnit, setCurrentUnit] = useState();
  const { fetchUnits, unitList, fetchBases, baseList } = useContext(store);
  const [corpuses, setCorpuses] = useState([]);
  const [search, setSearch] = useState("");
  const [isSelectedBase, setIsSelectedBase] = useState(null);
  const [selctedBase, setSelectedBase] = useState(null);
  const [added, setAdded] = useState(false);
  const [year, setYear] = useState(new Date().getFullYear());
  const [date, setDate] = useState(getDate(new Date()));
  const [showDate, setShowDate] = useState(false);

  useEffect(() => {
    fetchUnits();
  }, []);

  useEffect(() => {
    (async () => {
      const res = await axiosInstance.get("admin/corpuses");
      if (res.data.status) {
        setCorpuses(res.data.data);
      }
    })();
  }, []);

  useEffect(() => {
    if (added) {
      setTimeout(() => setAdded(false), 100);
    }
  }, [added]);

  const handleDateModal = (e) => {
    e.stopPropagation();
    setShowDate(!showDate);
  };

  const getExcelByCorpus = async (corpus) => {
    const res = await axiosInstance.get(
      `/admin/firing-excel/${corpus}/${year}`,
    );
    const { filePath } = res.data.data;

    const downloadLink = document.createElement("a");
    downloadLink.href = BACKEND_URL + filePath;
    downloadLink.download = "data.xlsx";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

    const getDailyExcelByCorpus = async (corpus) => {
    const res = await axiosInstance.get(
      `/admin/firing-daily-excel/${corpus}/${new Date(unGetDate(date)) + ""}`,
    );
    const { filePath } = res.data.data;

    const downloadLink = document.createElement("a");
    downloadLink.href = BACKEND_URL + filePath;
    downloadLink.download = "data.xlsx";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }

  const getFiringInfo = async (baseNumber) => {
    try {
      const response = await axiosInstance.get(`/admin/firing/${baseNumber}`);
      if (response.data.status) {
        setIsSelectedBase(true);
      }
    } catch (error) {
      console.error("Error fetching firing info:", error);
    }
  };

  const changeYear = (e) => {
    if (e.target.value > new Date().getFullYear()) {
      setYear(new Date().getFullYear());
    } else if (e.target.value < 2022) {
      setYear(2022);
    } else {
      setYear(e.target.value);
    }
  };

  const handleBackToUnits = () => {
    setIsBaseListShown(false);
    setSelectedName("Զորամաս");
    setCurrentUnit(null);
    setCurrentBase(null);
    setIsSelectedBase(false);
  };

  const changeSelectedBase = (base) => {
    setSelectedBase(base);
  };

  function getDate(date) {
    const parts = new Intl.DateTimeFormat("en-GB").formatToParts(date);
    const day = parts.find((p) => p.type === "day").value;
    const month = parts.find((p) => p.type === "month").value;
    const year = parts.find((p) => p.type === "year").value;
    const formatted = `${day}/${month}/${year}`;
    return formatted;
  }

  function unGetDate(date) {
    if (date) {
      const [day, month, year] = date.split("/");
      const formatted = `${month}/${day}/${year}`;
      return formatted;
    }
  }

  return (
    <div className={styles["main-div"]}>
      <div className={styles["body-div"]}>
        {!isBaseListShown && (
          <input
            type="text"
            placeholder="Որոնել"
            className={baseStyle["search-input"]}
            style={{ marginTop: "10px" }}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        )}

        <div className={styles["header-row"]}>
          {isBaseListShown && (
            <div className={styles["back-btn"]} onClick={handleBackToUnits}>
              <FontAwesomeIcon icon={faArrowLeft} />
            </div>
          )}
          <h2>{selectedName}</h2>
          {isBaseListShown && (
            <div>
              <FontAwesomeIcon
                icon={faPlus}
                className={styles["adding"]}
                title="Ավելացնել տվյալներ"
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedBase(baseList.data[0]);
                  setIsModalOpen(true);
                }}
              />
            </div>
          )}
        </div>

        <div className={styles["units-bases-div"]}>
          {!isBaseListShown ? (
            <div className={baseStyle["unit-list-container"]}>
              {!!unitList.filter(
                (el) =>
                  (el.unit_number.includes(search) ||
                    el.unit_close_number.includes(search)) &&
                  el.unit_corpus === "",
              ).length && (
                <div>
                  <h4 className={styles["corpus-header"]}>ՀԲԿ</h4>
                  <div className="flex absolute top-0 right-1">
                    <div
                      onClick={handleDateModal}
                      className="flex items-center justify-center"
                    >
                      <DatePicker
                        selected={date ? unGetDate(date) : null}
                        onChange={(date) => setDate(getDate(date))}
                        locale="hy"
                        dateFormat="dd MMMM yyyy"
                        className="border-b border-b-gray-400 rounded-lg outline-none mr-2 text-center"
                      />
                      <img
                        src="/excel.png"
                        alt="Excel"
                        className={`${styles["excel-icon"]} mr-5`}
                        onClick={() => {
                          getDailyExcelByCorpus(0);
                        }}
                      />
                    </div>
                    <input
                      type="number"
                      max={new Date().getFullYear()}
                      min="1900"
                      className={`${styles["year"]} mr-2`}
                      value={year}
                      onChange={changeYear}
                    />
                    <img
                      src="/excel.png"
                      alt="Excel"
                      className={styles["excel-icon"]}
                      onClick={() => {
                        getExcelByCorpus(0);
                      }}
                    />
                  </div>
                  {unitList
                    .filter(
                      (el) =>
                        (el.unit_number.includes(search) ||
                          el.unit_close_number.includes(search)) &&
                        el.unit_corpus === "",
                    )
                    .map((item, index) => (
                      <UnitListItem
                        key={index}
                        item={item}
                        index={index}
                        onClick={() => {
                          fetchBases(item.unit_number);
                          setIsBaseListShown(true);
                          setCurrentUnit({
                            number: item.unit_number,
                            name: item.unit_name,
                            corpus: item.unit_corpus,
                          });
                          setSelectedName("Հենակետեր");
                        }}
                      />
                    ))}
                </div>
              )}
              {corpuses.map((corpus, index) =>
                unitList.filter(
                  (el) =>
                    (el.unit_number.includes(search) ||
                      el.unit_close_number.includes(search)) &&
                    el.unit_corpus === corpus._id,
                ).length ? (
                  <div className={baseStyle["unit-list-container"]} key={index}>
                    <h4 className={styles["corpus-header"]}>
                      {corpus.corpus_number} {corpus.corpus_name}
                    </h4>
                    <div className="flex absolute top-0 right-1">
                      <div
                        onClick={handleDateModal}
                        className="flex items-center justify-center mr-5"
                      >
                        <DatePicker
                          selected={date ? unGetDate(date) : null}
                          onChange={(date) => setDate(getDate(date))}
                          locale="hy"
                          dateFormat="dd MMMM yyyy"
                          className="border-b border-b-gray-400 rounded-lg outline-none mr-2 text-center"
                        />
                        <img
                          src="/excel.png"
                          alt="Excel"
                          className={`${styles["excel-icon"]}`}
                          onClick={() => {
                            getDailyExcelByCorpus(corpus._id);
                          }}
                        />
                      </div>
                      <input
                        type="number"
                        max={new Date().getFullYear()}
                        min="1900"
                        className={`${styles["year"]} mr-2`}
                        value={year}
                        onChange={changeYear}
                      />
                      <img
                        src="/excel.png"
                        alt="Excel"
                        className={styles["excel-icon"]}
                        onClick={() => {
                          getExcelByCorpus(corpus._id);
                        }}
                      />
                    </div>
                    {unitList
                      .filter(
                        (el) =>
                          (el.unit_number.includes(search) ||
                            el.unit_close_number.includes(search)) &&
                          el.unit_corpus === corpus._id,
                      )
                      .map((item, index) => (
                        <UnitListItem
                          key={index}
                          item={item}
                          index={index}
                          onClick={() => {
                            fetchBases(item.unit_number);
                            setIsBaseListShown(true);
                            setCurrentUnit({
                              number: item.unit_number,
                              name: item.unit_name,
                              corpus: item.unit_corpus,
                            });
                            setSelectedName("Հենակետեր");
                          }}
                        />
                      ))}
                  </div>
                ) : (
                  ""
                ),
              )}
            </div>
          ) : baseList.data !== undefined && baseList.data.length > 0 ? (
            baseList.data.map((item, index) => (
              <div
                key={index}
                className={styles["editing-items"]}
                onClick={() => {
                  currentBase && currentBase._id === item._id
                    ? setCurrentBase(null)
                    : setCurrentBase(baseList.data[index]);
                  getFiringInfo(baseList.data[index]);
                  if (!currentBase) {
                    setIsSelectedBase(!isSelectedBase);
                  } else {
                    if (currentBase._id === item._id) {
                      setIsSelectedBase(!isSelectedBase);
                    }
                  }
                }}
              >
                <div className={styles["base-left-side"]}>
                  <p>
                    {index + 1}. {item.base_number}
                  </p>
                </div>
                {isSelectedBase && currentBase._id === item._id && (
                  <FiringInfo
                    baseList={baseList.data}
                    added={added}
                    base={currentBase}
                    item={item}
                    setIsSelectedBase={setIsSelectedBase}
                    changeSelectedBase={changeSelectedBase}
                    closeModal={() => {
                      setIsModalOpen(false);
                      setSelectedBase(null);
                    }}
                    unit={currentUnit}
                    setAdded={setAdded}
                  />
                )}
              </div>
            ))
          ) : (
            <div className={styles["empty"]}>Մուտքագրված հենակետեր չկան</div>
          )}
          {isModalOpen ? (
            <FiringParts
              base={selctedBase}
              baseList={baseList.data}
              changeSelectedBase={changeSelectedBase}
              closeModal={() => {
                setIsModalOpen(false);
                setSelectedBase(null);
              }}
              currentUnit={currentUnit}
              setAdded={setAdded}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};

export default Firing;
